export const CHECKBOX_TYPES = {
    check: 'checkMark',
    toggle: 'toggleMark',
    button: 'buttonMark'
};
